import Vue, { VueConstructor } from 'vue';

import ListItems from '@/common/components/listItems/ListItems.vue';
import ModalProduto from '@/common/components/modals/modalProduto/ModalProduto.vue'
import LinksConfig from '@/common/components/linksConfig/LinksConfig.vue'
import ModalAgendamento from '@/common/components/modals/modalAgendamento/ModalAgendamento.vue'
import DatepickerComponent from '@/common/components/datepicker/Datepicker.vue'
import HeaderComponent from '@/common/components/header/Header.vue'
import WhatsConfig from '@/common/components/linksConfig/whatsapp/Whats.vue'
import FlagConfig from '@/common/components/linksConfig/flag/Flag.vue'

export function registerVueGlobalComponent(vue: VueConstructor<Vue>) {
    [
        { component: ListItems, selector: 'listItems' }
        ,{ component: ModalProduto, selector: 'modalProduto' }
        ,{ component: LinksConfig, selector: 'linksConfig' }
        ,{ component: ModalAgendamento, selector: 'modalAgendamento' }
        ,{ component: DatepickerComponent, selector: 'datePicker' }
        ,{ component: HeaderComponent, selector: 'headerComponent' }
        ,{ component: WhatsConfig, selector: 'whatsConfig' }
        ,{ component: FlagConfig, selector: 'flagConfig' }
    ]
    .forEach(config => vue.component(config.selector, config.component));
}